/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Picture from 'components/Picture/Picture';
import VideoBackground from 'components/VideoBackground/VideoBackground';
import './SpannedImageText.scss';

/**
 * This is the SpannedImageText component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function SpannedImageText({ layout, image, video, text, photographer }) {
  function renderVideo() {
    if (!video) return null;
    return <VideoBackground {...video} />;
  }

  function renderPhotographer() {
    if (!photographer) return null;

    return <small className="photographer">{photographer}</small>;
  }

  return (
    <div className={`block spanned-image-text layout-${layout}`}>
      <div className="image" appear="true">
        <Picture {...image} />
        {renderVideo()}
      </div>
      <div className="text">
        <p dangerouslySetInnerHTML={{ __html: text }} stagger-text="true" />
      </div>
      {renderPhotographer()}
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
SpannedImageText.propTypes = {
  layout: PropTypes.oneOf(['left', 'right']).isRequired,
  image: PropTypes.object,
  video: PropTypes.object,
  text: PropTypes.string,
  photographer: PropTypes.string,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
SpannedImageText.defaultProps = {
  layout: 'left',
  image: {},
  text: '',
  photographer: '',
};

export default SpannedImageText;
